import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-seating-chart',
    templateUrl: './seating-chart.component.html',
    styleUrls: ['./seating-chart.component.scss']
})
export class SeatingChartComponent {
    @Input() seatingChart: any;

    constructor() { }

    /**
     * Create a unique ID for the modal components
     *
     * @param str
     */
    getToolTipModalId(str: string) {
        return str.toLowerCase().replace(/[^0-9a-z\-]+/, '');
    }
}
